import envConfig from "env/EnvConfig";
import axios from 'axios';

const getApiInstance = () =>
{
    let instance = axios.create({});
    delete instance.defaults.headers.common['x-api-key'];
    delete instance.defaults.headers.common['vcmid'];
    delete instance.defaults.headers.common['msrid'];
    delete instance.defaults.headers.common['fismemberid'];
    return instance;
}

const getInvestorUrl = () => {
    let modifiedUrl = envConfig.HOST;
    modifiedUrl = modifiedUrl.replace('investorapi','investor');

    try {
        return new URL(modifiedUrl).host;
    } catch (error) {
        return modifiedUrl.replace(/^https?:\/\//, '');
    }
}

const loadAEMHtmlData = async (url) => {
    let apiStatus = 0;
    const instance = getApiInstance();
    
    return await instance
        .get(url, { headers: { Authorization: `${envConfig.PRELOGIN_HEADER_AUTH}` } })
        .then(response => {
            apiStatus = response.status;

            if (response) {
                return response.data;
            }
            
            throw new Error('Error message.');
        })
        .then(data => {
            let result = data.toString();

            let investorUrlString = getInvestorUrl()
     
            result = result.replace(/src="\//g, `src="${envConfig.ENV_URL}/`);
            result = result.replace(/href="\//g, `href="${envConfig.ENV_URL}/`);
            result = result.replace(/value="\/content/g, `value="${envConfig.ENV_URL}/content`);
            result = result.replace(`src="https://${investorUrlString}//assets.adobedtm.com`, `src="https://assets.adobedtm.com`);
            result = result.replace(`src="${investorUrlString}/etc.clientlibs/vcm/clientlibs/jquery.mCustomScrollbar.min.js.map`, `src=""`);
            result = result.replace(`src="${investorUrlString}/etc.clientlibs/vcm/clientlibs/jquery.mCustomScrollbar.min.js`, `src=""`);
            
            return {
                result,
                apiStatus
            };
        })
        .catch(err => {
            return {
                apiStatus:0
            }
        });
};

const renderAEMHtml = async (html, containerId) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const container = document.getElementById(containerId);

    console.log("Updated code Call")
    if (!container) {
        console.error(`Container '${containerId}' not found`);
        return;
    }

    // Collect all scripts
    const scripts = [...doc.querySelectorAll("script")];


    // Remove them from HTML
    scripts.forEach(script => script.remove());

    const links = [...doc.querySelectorAll('link[rel="stylesheet"]')];
       
        links.forEach(link => {
        const href = link.href;

        // Avoid adding duplicates
        if (!document.querySelector(`link[href="${href}"]`)) {
            const newLink = document.createElement("link");
            newLink.rel = "stylesheet";
            newLink.href = href;
            document.head.appendChild(newLink);
        }
    });

     
    // Render only HTML
    container.innerHTML = doc.body.innerHTML;

    // Load scripts sequentially
    for (const oldScript of scripts) {

       if (
        oldScript.src &&
        oldScript.src.includes("rum.hlx.page")
        ) {
            console.log("Skipping:", oldScript.src);
            continue;
        }

        if (oldScript.src) {

            await new Promise((resolve) => {

                const script = document.createElement("script");

                script.src = oldScript.src;
                script.async = false;
                script.defer = false;

                let settled = false;
                const settle = (callback) => {
                    if (!settled) {
                        settled = true;
                        callback();
                    }
                };

                script.onload = () => {
                    console.log("Loaded:", script.src);
                    settle(resolve);
                };

                script.onerror = () => {
                    console.warn("Failed:", script.src);

                    // Continue loading remaining scripts
                    settle(resolve);
                };

                document.body.appendChild(script);

            });

        } else if (oldScript.innerHTML.trim()) {

           try {
                const inlineScript = document.createElement("script");
                inlineScript.text = oldScript.innerHTML;
                document.body.appendChild(inlineScript);
            } catch (e) {
                console.warn("Inline script failed", e);
            }

        }
    }
};



const hideDomElements = () => {
    const hideClassNames = [
        'breadcrumb aem-GridColumn aem-GridColumn--default--12',
        'experiencefragment aem-GridColumn aem-GridColumn--default--12'
    ];

    const headerElement = document.getElementsByClassName(
        "header aem-GridColumn aem-GridColumn--default--12"
    );

    if (headerElement.length > 0) {
        const elements =
            headerElement[0]?.parentElement?.parentElement?.parentElement?.parentElement?.children;

        Array.from(elements || []).forEach(elem => {
            if (hideClassNames.includes(elem.className)) {
                elem.style.display = "none";
            }
        });
    }

    const footerElement = document.getElementsByClassName(
        "footer aem-GridColumn aem-GridColumn--default--12"
    )[0];

    if (footerElement) {
        footerElement.parentElement.parentElement.parentElement.style.display = "none";
    }

    const fixContainer = document.getElementsByClassName("fix-container")[0];
    if (fixContainer) {
        fixContainer.style.display = "contents";
    }

    // Hide ALL buy buttons
    document.querySelectorAll(".mf-buy-btn").forEach(button => {
        button.style.setProperty("display", "none", "important");
    });
};

const generatePageUrl = (selectedFund) => {
    const fundName = selectedFund?.fundName;
    let pageURL = fundName?.toLowerCase()?.replace(/ & /g, "-").replace(/ /g, "-").replace(/\//g,"-");
    if (pageURL && pageURL.includes("usaa-500-index-")) {
        pageURL += '-shares';
    }
    return pageURL;
}

const hidePostLoginFooterDisclosure = (hideFooter) => {
    const footer = document.getElementById("fund-disclosure-footer");
     if (!footer) {
        return;
    }

    footer.style.display = hideFooter ? "none" : "block";
}

export {
    loadAEMHtmlData,
    hideDomElements,
    generatePageUrl,
    hidePostLoginFooterDisclosure,
    renderAEMHtml
}
